import { render, staticRenderFns } from "./TopProductsDrillDown.vue?vue&type=template&id=78d60b56"
import script from "./TopProductsDrillDown.vue?vue&type=script&lang=js"
export * from "./TopProductsDrillDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports